import customFetch from '../utils/fetch';
import { API_ENDPOINTS } from '../constants/api-endpoint';

const save = async (data) => {
  try {
    return await customFetch(API_ENDPOINTS.ROUTE_REGISTRATION_SAVE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
  } catch (error) {
    console.error('交通経路情報の保存エラー:', error);
    throw error;
  }
};

const getRegistration = async (data) => {
  try {
    return await customFetch(API_ENDPOINTS.ROUTE_REGISTRATION_GET, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
  } catch (error) {
    console.error('交通経路情報の取得エラー:', error);
    throw error;
  }
};

const update = async (data) => {
  try {
    return await customFetch(API_ENDPOINTS.ROUTE_REGISTRATION_UPDATE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
  } catch (error) {
    console.error('交通経路情報の更新エラー:', error);
    throw error;
  }
};

export const routeService = {
  save,
  getRegistration,
  update
};
